<template>
    <div v-if="member != null && checkLiveAuction">
        <div>
            <a type="button" v-if="checkPermissionAuction"
               class="btn btn-danger-small btn-live d-flex align-items-center justify-content-center "
               v-bind:href="'/auction/live'">
                <img src="/img/home/icon-live.svg" class="mr-1 text-live-mobile" alt="">
                <div>LIVE <span>参加
<!--                    <span class="text-live-mobile">はこちら</span>-->
                </span></div>
<!--                <img src="/img/home/icon-arrow-right.svg" class="ml-1" alt="">-->
            </a>
            <button data-toggle="modal" data-target="#modalConfirmBid" v-else
                    class="btn btn-danger-small btn-live d-flex align-items-center justify-content-center">
                <img src="/img/home/icon-live.svg" class="mr-1 text-live-mobile" alt="">
                <div>LIVE <span>参加
<!--                    <span class="text-live-mobile">はこちら</span>-->
                </span></div>
<!--                <img src="/img/home/icon-arrow-right.svg" class="ml-1" alt="">-->
            </button>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {

    },
    async created() {
        await this.getDataLiveAuction();

        Echo.channel('auction.live')
            .listen('.auction.live', (e) => {
                this.getDataLiveAuction();
            });
    },
    data: function () {
        return {
            member: null,
            checkLiveAuction: null,
            checkPermissionAuction: null
        }
    },
    methods: {
        async getDataLiveAuction() {
            await axios.post('/bid/get-data-check-live')
                .then(response => {
                    this.member = response.data.member;
                    this.checkLiveAuction = response.data.checkLiveAuction;
                    this.checkPermissionAuction = response.data.checkPermissionAuction;
                })
                .catch(error => {

                })
        },
    },
}
</script>
